<script setup lang="ts">
import { mdToHtml } from '~/lib/markdown'
import { BlockTextFullScreen } from '~/lib/services/content/content.blocks.dtos'

const props = defineProps<{
  block: BlockTextFullScreen
}>()

const BACKGROUND_COLORS: { [key: string]: string } = {
  yellow: 'bg-mcd-main',
  white: 'bg-white',
  grey: 'bg-mcd-secondaryIvory',
}

const backgroundColor = computed(() => BACKGROUND_COLORS[props.block?.backgroundColor ?? 'white'])

const buttonColor = computed(() => {
  return props.block.backgroundColor === 'white' ? 'bg-mcd-main' : 'bg-mcd-black text-white'
})

const htmlContent = computed(() => {
  if (!props.block.content) return ''
  return mdToHtml(props.block.content)
})
</script>

<template>
  <section :class="backgroundColor" class="flex flex-col px-4 py-8 md:px-8 lg:px-[104px] lg:py-20">
    <header class="flex flex-col gap-4">
      <h2
        v-if="block.title"
        class="text-[32px] font-bold leading-9 tracking-[-0.15px] lg:text-[68px] lg:leading-[80px]"
      >
        {{ block.title }}
      </h2>
      <p
        v-dompurify-html="htmlContent"
        class="text-sm leading-4 tracking-[-0.15px] lg:text-lg lg:leading-6"
      ></p>
    </header>
    <footer
      v-if="block.primaryBtn || block.secondaryBtn"
      class="mt-8 grid grid-cols-2 gap-6 md:flex md:items-start lg:mt-10 lg:gap-4"
    >
      <SimpleLink v-if="block.primaryBtn" :link="block.primaryBtn">
        <McdButton :class="buttonColor" class="h-10 w-full md:w-40" is-primary>
          {{ block.primaryBtn?.title }}
        </McdButton>
      </SimpleLink>
      <SimpleLink v-if="block.secondaryBtn" :link="block.secondaryBtn">
        <McdButton class="h-10 w-full bg-transparent md:w-40" is-secondary>
          {{ block.secondaryBtn?.title }}
        </McdButton>
      </SimpleLink>
    </footer>
  </section>
</template>
